<template>
  <div class="home">
    <h1>Doodle.IO</h1>
  </div>

  <div>
    <Avatar :imgLoc="this.img" />
    <div id="avatar-container">
      <button @click="previousImg" class="avatar-buttons">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-left svg"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
          />
        </svg>
      </button>
      <button @click="randomImg" class="avatar-buttons">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-dice-6-fill"
          viewBox="0 0 16 16"
        >
          <path
            d="M3 0a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3zm1 5.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm8 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1.5 6.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM12 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM5.5 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM4 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z"
          />
        </svg>
      </button>
      <button @click="nextImg" class="avatar-buttons">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
          />
        </svg>
      </button>
    </div>
  </div>
  <input
    type="text"
    v-model="playerName"
    placeholder="Player name"
    id="name-input"
    autocomplete="off"
  />
  <button @click="joinGame" class="buttons">JOIN</button>
  <button @click="createCustomRoom" class="buttons" id="button2">
    CREATE ROOM
  </button>
</template>

<script>
  import * as socketio from '../plugins/socketio';
  import Avatar from './Avatar.vue';
  export default {
    components: {
      Avatar,
    },
    data() {
      return {
        playerName: '',
        img: 1,
        customRoomId: null,
      };
    },
    methods: {
      joinGame() {
        //get params from the url
        // this.customRoomId = this.$route.query.id.replace(/\s+/g, ' ').trim()
        // this.customRoomId = this.$route.params.id

        // this.showWaitingRoom = true;
        // integrated autofill username

        this.customRoomId = this.$route.query.id;
        console.log('url room ID:', this.customRoomId);
        if (this.playerName.trim() === '') {
          console.log('empty field username');
          // create random Name
          const api = `https://random-words-api.vercel.app/word`;
          fetch(api)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this.playerName = data[0].word;
              socketio.sendEvent({
                type: 'playerData',
                data: {
                  playerName: this.playerName,
                  customRoomId: this.customRoomId,
                  avatar: this.img,
                },
              });
            });
        } else {
          socketio.sendEvent({
            type: 'playerData',
            data: {
              playerName: this.playerName,
              customRoomId: this.customRoomId,
              avatar: this.img,
            },
          });
        }

        // sks
        //  this.customRoomId = this.$route.query.id;
        // console.log('CustomID from URL:',this.customRoomId);
        // console.log('url room ID:', this.customRoomId)
        // console.log('sent PlayerInfo');
        // socketio.sendEvent({
        //   type: 'playerData',
        //   data: { playerName: this.playerName, customRoomId: this.customRoomId, avatar: this.img },
        // });
      },
      createCustomRoom() {
        if (this.playerName.trim() === '') {
          console.log('empty field username');
          // create random Name
          const api = `https://random-words-api.vercel.app/word`;
          fetch(api)
            .then((response) => {
              return response.json();
            })
            .then((data) => {
              this.playerName = data[0].word;
              socketio.sendEvent({
                type: 'createCustomRoom',
                data: { playerName: this.playerName, avatar: this.img },
              });
            });
        } else {
          socketio.sendEvent({
            type: 'createCustomRoom',
            data: { playerName: this.playerName, avatar: this.img },
          });
        }
        // socketio.sendEvent({
        //   type: 'createCustomRoom',
        //   data: { playerName: this.playerName, avatar: this.img },
        // });
      },
      nextImg() {
        if (this.img <= 9) {
          this.img += 1;
        } else {
          this.img = 1;
        }
      },
      previousImg() {
        if (this.img <= 1) {
          this.img = 10;
        } else {
          this.img -= 1;
        }
      },
      randomImg() {
        this.img = Math.floor(Math.random() * 10 + 1);
      },
    },
  };
</script>

<style scoped>
  h1 {
    font-family: 'VT323';
    user-select: none;
    font-size: 4em;
    color: white;
  }
  .links {
    text-decoration: none;
  }
  #name-input {
    display: block;
    margin: auto;
    width: 300px;
    height: 50px;
    border-radius: 10px;
    text-align: left;
    border: 2px solid white;
    background: transparent;
    margin-top: 40px;
    color: white;
    outline: none;
    padding-left: 30px;
    font-family: 'ZCOOL KuaiLe';
    font-weight: 700;
    font-size: 1.2em;
  }
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: white;
    opacity: 1; /* Firefox */
  }
  .buttons {
    display: block;
    margin: auto;
    margin-top: 39px;
    width: 220px;
    height: 55px;
    border-radius: 33px;
    border: none;
    font-family: 'ZCOOL KuaiLe';
    background-color: royalblue;
    color: rgb(120, 226, 120);
    cursor: pointer;
    font-size: 1.13em;
  }

  #button2 {
    background-color: white;
    color: royalblue;
    width: 350px;
    margin-top: 30px;
  }
  .avatar-buttons {
    background-color: royalblue;
    color: white;
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 5px;
    margin-right: 5px;
    cursor: pointer;
  }
  .svg {
    display: block;
    margin: auto;
  }
  #avatar-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
  }
</style>
